export var brokingAccountMapper = function (data) {
    var result = {};
    if (data) {
        result = {
            cash: (data === null || data === void 0 ? void 0 : data.cash) ? Math.abs(Number(data.cash)).toString() : "",
            stock: data.stock,
            margin: data.margin ? Math.abs(Number(data.margin)).toString() : "",
            smtF_Interest: data.smtF_INTEREST,
            dpc: data.dpc,
            adbPlan: data.adbplan,
            adbAmount: data.adbamount,
            expiryDate: data.expirydt,
            adBConsumed: data.adB_CONSUMED,
            shortFall: data.shortfall,
            age: data.age,
            smtF_DPC_Rate: data === null || data === void 0 ? void 0 : data.smtF_DPC_Rate,
            fnO_DPC_Rate: data === null || data === void 0 ? void 0 : data.fnO_DPC_Rate,
        };
    }
    return result;
};
